import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Sankalpbydheeraj() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/7801a043516846a4a444dbea2a0ffa32.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
          <p>ENGLISH  ENGLISH</p>
          <h4>Sankalp 2022 (NDA I): Complete Course on English</h4> 
          <p>Ended on Jan 4, 2022 • 37 lessons</p> 
          <p>Dheeraj</p>  
        </div>
    </div>        
  )
}
export default Sankalpbydheeraj;